
(function() {
  'use strict';

  function stopHiddenVideos() {
    document.querySelectorAll('native-video[hidden] video, native-video:not([hidden]) video').forEach(video => {
      const wrapper = video.closest('native-video');
      
      // Check if this video wrapper has autoplay class
      const hasAutoplay = wrapper && wrapper.classList.contains('soll-autoplay');
      
      if (wrapper && wrapper.hasAttribute('hidden') && !video.paused && !hasAutoplay) {
        video.pause();
      }
    });
  }

  function stopOutOfViewVideos() {
    document.querySelectorAll('native-video:not([hidden]) video').forEach(video => {
      const wrapper = video.closest('native-video');
      if (!wrapper) return;

      // Check if this video wrapper has autoplay class
      const hasAutoplay = wrapper.classList.contains('soll-autoplay');
      
      const rect = wrapper.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

      if (!isVisible && !video.paused && !hasAutoplay) {
        video.pause();
      }
    });
  }

  function checkAndStopVideos() {
    stopHiddenVideos();
    stopOutOfViewVideos();
  }
  
  document.addEventListener('click', (e) => {
    if (e.target.closest('.image-with-text__navigation-item, page-dots button')) {
      setTimeout(checkAndStopVideos, 100);
    }
  });

  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(checkAndStopVideos, 200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndStopVideos);
  } else {
    checkAndStopVideos();
  }

})();




async function initializeQuantityBreaks() {
  const allQuantityBreaksElements = document.querySelectorAll("quantity-breaks");
  if (allQuantityBreaksElements.length === 0) {
    return;
  }
  
  for (const quantityBreaksElement of allQuantityBreaksElements) {
    await initializeSingleQuantityBreak(quantityBreaksElement);
  }
}

async function initializeSingleQuantityBreak(quantityBreaksElement) {
  const sectionId = quantityBreaksElement.dataset.section;
  const flickityCarouselWrapper = document.querySelector(".product__media-list-wrapper .product__media-list");

  async function getFlickityInstance() {
    return new Promise((resolve) => {
      const checkInstance = async () => {
        if (flickityCarouselWrapper?.children.length <= 1) {
          resolve(null);
          return;
        }
        const flickityInstance = await flickityCarouselWrapper?.flickityInstance;
        if (flickityInstance) {
          resolve(flickityInstance);
        } else {
          setTimeout(checkInstance, 200);
        }
      };
      checkInstance();
    });
  }

  let flickityInstance = null;
  let mediaElements = [];
  
  if (flickityCarouselWrapper) {
    try {
      flickityInstance = await getFlickityInstance();
      mediaElements = Array.from(flickityCarouselWrapper.querySelectorAll("[data-media-id]") || []);
    } catch (error) {
      // Flickity nicht verfügbar, weiter ohne Flickity
    }
  }
  
  function getMasterSelectForCurrentLabel() {
    const activeRadio = quantityBreaksElement.querySelector("input[name='quantity']:checked");
    if (!activeRadio) return null;
    
    const radioId = activeRadio.id;
    const quantityMatch = radioId.match(/quantity(\d+)/);
    if (!quantityMatch) return null;
    
    const quantityNumber = quantityMatch[1];
    return document.getElementById(`master-select-${sectionId}-q${quantityNumber}`);
  }

  function scrollToMedia(mediaId) {
    let targetIndex = mediaElements.findIndex(el => el.getAttribute("data-media-id") === mediaId);
    if (targetIndex !== -1) {
      if (flickityInstance && flickityInstance.select) {
        flickityInstance.select(targetIndex);
      } else {
        mediaElements[targetIndex].scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  }

  function getChangedSelectorItem(element) {
    return element.closest(".quantity-break__selector-item");
  }

  function updateMasterSelect(changedSelector) {
    const currentMasterSelect = getMasterSelectForCurrentLabel();
    if (!changedSelector || !currentMasterSelect) return;
    
    const selectedOptions = changedSelector.querySelectorAll(".combo-box__option-item[aria-selected='true']");
    let selectedValues = Array.from(selectedOptions).map(option => option.getAttribute("value"));

    let matchingOption = Array.from(currentMasterSelect.options).find(option =>
      selectedValues.every(val => option.textContent.includes(val))
    );

    if (!matchingOption) return;

    currentMasterSelect.value = matchingOption.value;
    const selectedMediaId = matchingOption.getAttribute("data-media-id");
    if (selectedMediaId) {
      scrollToMedia(selectedMediaId);
    }
  }

  function setButtonStatus(isAvailable, text = null) {
    let addToCartButton = quantityBreaksElement.querySelector("#AddToCart, [id*='AddToCart']");
    
    if (!addToCartButton) {
      const parentContainer = quantityBreaksElement.closest('quick-buy-popover, quick-buy-drawer, form');
      if (parentContainer) {
        addToCartButton = parentContainer.querySelector("#AddToCart, [id*='AddToCart']");
      }
    }
    
    if (!addToCartButton) {
      addToCartButton = document.getElementById("AddToCart");
    }
    
    if (!addToCartButton) return;

    const buttonText = addToCartButton.querySelector('.loader-button__text');
    
    if (isAvailable) {
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('button--ternary');
      addToCartButton.classList.add('button--primary');
      if (buttonText) buttonText.textContent = text || 'Add to cart';
    } else {
      addToCartButton.disabled = true;
      addToCartButton.classList.add('button--ternary');
      addToCartButton.classList.remove('button--primary');
      if (buttonText) buttonText.textContent = text || 'Sold out';
    }
  }

  function checkAvailability() {
    const activeRadio = quantityBreaksElement.querySelector("input[name='quantity']:checked");
    if (!activeRadio) {
      setButtonStatus(false, 'Select quantity');
      return;
    }

    const activeQtyBreak = quantityBreaksElement.querySelector(`label[for='${activeRadio.id}']`);
    if (!activeQtyBreak) {
      setButtonStatus(false);
      return;
    }

    if (activeQtyBreak.classList.contains('quantity-break--sold-out')) {
      setButtonStatus(false, 'Sold out');
      return;
    }

    const variantSelectors = activeQtyBreak.querySelectorAll(".quantity-break__selector-item");
    
    if (variantSelectors.length === 0) {
      setButtonStatus(true);
      return;
    }

    let hasSoldOutVariant = false;
    variantSelectors.forEach(selector => {
      const selectedOptions = selector.querySelectorAll('.combo-box__option-item[aria-selected="true"].disabled');
      if (selectedOptions.length > 0) {
        hasSoldOutVariant = true;
      }
    });

    if (hasSoldOutVariant) {
      setButtonStatus(false, 'Sold out');
    } else {
      setButtonStatus(true);
    }
  }

  // UNIFIED SUBSCRIPTION SYSTEM
  function toggleSubscriptionElements() {
    const subscriptionToggle = document.querySelector('input[name="shipping-switch-new-product"]');
    const isSubscriptionEnabled = subscriptionToggle ? subscriptionToggle.checked : false;
    
    // Simple class toggle - CSS handles the rest
    if (isSubscriptionEnabled) {
      quantityBreaksElement.classList.add('subscription-active');
    } else {
      quantityBreaksElement.classList.remove('subscription-active');
    }
    
    // Handle free items visibility based on setting
    updateFreeItemsVisibility();
    
    // Trigger smooth transition for better UX
    quantityBreaksElement.style.transition = 'all 0.2s ease';
    setTimeout(() => {
      quantityBreaksElement.style.transition = '';
    }, 200);
  }

  function initializeSubscriptionElements() {
    const subscriptionToggle = document.querySelector('input[name="shipping-switch-new-product"]');
    const isSubscriptionEnabled = subscriptionToggle ? subscriptionToggle.checked : false;
    const hideFreeItems = quantityBreaksElement.dataset.hideFreeItems === 'true';
    
    // Set initial state
    if (isSubscriptionEnabled) {
      quantityBreaksElement.classList.add('subscription-active');
    } else {
      quantityBreaksElement.classList.remove('subscription-active');
    }
    
    // Add CSS class for conditional free items
    if (hideFreeItems) {
      quantityBreaksElement.classList.add('hide-free-items-without-subscription');
    }
  }

  // Handle conditional free items logic (kept for backward compatibility)
  function shouldShowFreeItems() {
    const subscriptionToggle = document.querySelector('input[name="shipping-switch-new-product"]');
    const hideFreeItems = quantityBreaksElement.dataset.hideFreeItems === 'true';
    const isSubscriptionEnabled = subscriptionToggle ? subscriptionToggle.checked : false;
    
    // If hide_free_items is false, always show
    // If hide_free_items is true, only show when subscription is enabled
    return !hideFreeItems || (hideFreeItems && isSubscriptionEnabled);
  }

  function updateFreeItemsVisibility() {
    // This function is now mostly handled by CSS, but kept for compatibility
    // The CSS classes .hide-free-items-without-subscription and .subscription-active
    // handle the visibility logic automatically
    
    const shouldShow = shouldShowFreeItems();
    const freeSelectors = quantityBreaksElement.querySelectorAll('.quantity-break__selector-item[data-is-free="true"]');
    
    // Only need JavaScript intervention for edge cases
    freeSelectors.forEach(selector => {
      // Remove any force-hidden class to let CSS take over
      selector.classList.remove('force-hidden');
    });
  }

  // Initialisierung
  initializeSubscriptionElements();
  updateFreeItemsVisibility();
  
  setTimeout(() => {
    checkAvailability();
  }, 100);

  // Event Listeners
  const subscriptionToggle = document.querySelector('input[name="shipping-switch-new-product"]');
  if (subscriptionToggle) {
    subscriptionToggle.addEventListener('change', () => {
      toggleSubscriptionElements();
      updateFreeItemsVisibility();
    });
  }

  const quantityRadios = quantityBreaksElement.querySelectorAll('input[name="quantity"]');
  quantityRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      checkAvailability();
    });
  });

  const comboOptions = quantityBreaksElement.querySelectorAll(".combo-box__option-item");
  comboOptions.forEach(option => {
    option.addEventListener("click", function () {
      const changedSelector = getChangedSelectorItem(this);
      this.parentElement.querySelectorAll(".combo-box__option-item").forEach(sibling => sibling.setAttribute("aria-selected", "false"));
      this.setAttribute("aria-selected", "true");
      updateMasterSelect(changedSelector);
      checkAvailability();
    });
  });

  const selectButtons = quantityBreaksElement.querySelectorAll('.quantity-break__selector-item button[role="option"]');
  selectButtons.forEach(button => {
    button.addEventListener("click", function (event) {
      const selectedValue = event.target.getAttribute("value");
      const selectWrapper = event.target.closest('.select-wrapper');
      const selectElement = selectWrapper.querySelector('select');
      const selectedDisplay = selectWrapper.querySelector('.select__selected-value');
      const comboBox = selectWrapper.querySelector('.combo-box');

      if (selectElement) {
        selectElement.value = selectedValue;
        const changeEvent = new Event("change", { bubbles: true });
        changeEvent.preventStickyBarUpdate = true;
        selectElement.dispatchEvent(changeEvent);
      }

      if (selectedDisplay) {
        selectedDisplay.innerHTML = event.target.innerHTML;
      }

      if (comboBox) {
        comboBox.removeAttribute("open");
      }
      
      checkAvailability();
    });
  });

  document.addEventListener("change", function (event) {
    if (event.target.closest(".quantity-breaks") && event.preventStickyBarUpdate) {
      event.stopImmediatePropagation();
    }
  }, true);

  function initializeAddToCart() {
    let addToCartButton = quantityBreaksElement.querySelector("#AddToCart, [id*='AddToCart']");
    
    if (!addToCartButton) {
      const parentContainer = quantityBreaksElement.closest('quick-buy-popover, quick-buy-drawer, form');
      if (parentContainer) {
        addToCartButton = parentContainer.querySelector("#AddToCart, [id*='AddToCart']");
      }
    }
    
    if (!addToCartButton) {
      addToCartButton = document.getElementById("AddToCart");
    }
    
    if (!addToCartButton) return;

    const initFlag = `data-qty-breaks-initialized-${sectionId}`;
    if (addToCartButton.hasAttribute(initFlag)) {
      return;
    }

    const activeRadio = quantityBreaksElement.querySelector("input[name='quantity']:checked");
    if (!activeRadio) {
      return;
    }

    const activeQtyBreak = quantityBreaksElement.querySelector(`label[for='${activeRadio.id}']`);
    const hasVariantSelectors = activeQtyBreak?.querySelectorAll(".quantity-break__selector-item").length > 0;
    const quantityRadios = quantityBreaksElement.querySelectorAll('input[name="quantity"]');
    const totalQuantity = parseInt(activeQtyBreak?.dataset.quantity || '1');
    
    const needsCustomHandler = (
      hasVariantSelectors ||
      quantityRadios.length > 1 ||
      totalQuantity > 1 ||
      quantityBreaksElement.querySelector('select[id*="master-select"]')
    );
    
    if (!needsCustomHandler) {
      return;
    }

    addToCartButton.setAttribute(initFlag, 'true');

    addToCartButton.addEventListener("click", async function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      toggleLoader(true);

      const activeRadio = quantityBreaksElement.querySelector("input[name='quantity']:checked");
      if (!activeRadio) {
        toggleLoader(false);
        return;
      }

      const activeQtyBreak = quantityBreaksElement.querySelector(`label[for='${activeRadio.id}']`);
      if (!activeQtyBreak) {
        toggleLoader(false);
        return;
      }

      if (activeQtyBreak.classList.contains('quantity-break--sold-out')) {
        event.preventDefault();
        toggleLoader(false);
        return;
      }

      const variantSelectors = activeQtyBreak.querySelectorAll(".quantity-break__selector-item");
      let hasSoldOutVariant = false;
      
      variantSelectors.forEach(selector => {
        const selectedOptions = selector.querySelectorAll('.combo-box__option-item[aria-selected="true"].disabled');
        if (selectedOptions.length > 0) {
          hasSoldOutVariant = true;
        }
      });

      if (hasSoldOutVariant) {
        event.preventDefault();
        toggleLoader(false);
        return;
      }

      let totalQuantity = parseInt(activeQtyBreak.dataset.quantity, 10) || 1;

      const productHandle = quantityBreaksElement?.dataset.handle;
      let productVariants = [];

      if (productHandle) {
        try {
          const response = await fetch(`/products/${productHandle}.js`);
          if (!response.ok) throw new Error();
          const productData = await response.json();
          productVariants = productData?.variants || [];
        } catch (error) {
          toggleLoader(false);
          return;
        }
      } else {
        toggleLoader(false);
        return;
      }

      if (variantSelectors.length === 0) {
        const currentMasterSelect = getMasterSelectForCurrentLabel();
        let variantId = null;
        
        if (currentMasterSelect && currentMasterSelect.value) {
          variantId = parseInt(currentMasterSelect.value);
        } else if (productVariants.length === 1) {
          variantId = productVariants[0].id;
        } else if (productVariants.length > 0) {
          const availableVariant = productVariants.find(v => v.available);
          variantId = availableVariant ? availableVariant.id : productVariants[0].id;
        }
        
        if (variantId) {
          const success = await addToCart(variantId, totalQuantity);
          if (success) updateCart();
        }
        
        toggleLoader(false);
        return;
      }

      const variantGroups = [];
      variantSelectors.forEach(group => {
        const optionSelectors = group.querySelectorAll('combo-box select');
        const selectedOptions = Array.from(optionSelectors).map(select => select.value);
        const isFree = group.getAttribute('data-is-free') === 'true';
        variantGroups.push({ options: selectedOptions, isFree: isFree });
      });

      let selectedVariants = [];
      variantGroups.forEach(group => {
        const foundVariant = productVariants.find(variant => {
          let variantOptions = [];
          if (variant.option1) variantOptions.push(variant.option1);
          if (variant.option2) variantOptions.push(variant.option2);
          if (variant.option3) variantOptions.push(variant.option3);
          if (variantOptions.length === 0 && variant.public_title) {
            variantOptions = variant.public_title.split(" / ");
          }
          return group.options.every(option => variantOptions.includes(option));
        });

        if (foundVariant) {
          selectedVariants.push({ variant: foundVariant, isFree: group.isFree });
        }
      });

      if (selectedVariants.length === 0) {
        toggleLoader(false);
        return;
      }

      const variantMap = new Map();

      selectedVariants.forEach((item) => {
        const variantId = item.variant.id;

        if (variantMap.has(variantId)) {
          const existing = variantMap.get(variantId);
          variantMap.set(variantId, {
            paidQuantity: existing.paidQuantity + (item.isFree ? 0 : 1),
            totalQuantity: existing.totalQuantity + 1,
            variant: item.variant
          });
        } else {
          variantMap.set(variantId, {
            paidQuantity: item.isFree ? 0 : 1,
            totalQuantity: 1,
            variant: item.variant
          });
        }
      });

      for (const [variantId, data] of variantMap.entries()) {
        if (data.paidQuantity > 0) {
          await addToCart(variantId, data.paidQuantity);
        }
        
        if (data.totalQuantity > data.paidQuantity) {
          const shouldAddFreeItems = shouldShowFreeItems();
          
          if (shouldAddFreeItems) {
            await addToCartFree(variantId, data.totalQuantity - data.paidQuantity);
          }
        }
      }

      updateCart();
      toggleLoader(false);
    });
  }

  async function addToCartFree(variantId, quantity) {
    try {
      let cartItemData = { 
        id: variantId, 
        quantity: quantity,
        properties: {
          '_free_item': 'true'
        }
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartItemData)
      });

      if (!response || !response.ok) return false;
      return true;
    } catch (error) {
      return false;
    }
  }

  async function addToCart(variantId, quantity) {
    try {
      const subscriptionToggle = document.querySelector('input[name="shipping-switch-new-product"]');
      const isSubscriptionEnabled = subscriptionToggle ? subscriptionToggle.checked : false;
      
      let cartItemData = { id: variantId, quantity };
      
      if (isSubscriptionEnabled) {
        const currentMasterSelect = getMasterSelectForCurrentLabel();
        if (currentMasterSelect) {
          const variantOption = currentMasterSelect.querySelector(`option[value="${variantId}"]`);
          const sellingPlanId = variantOption ? variantOption.getAttribute('data-selling-plan-id') : null;
          
          if (sellingPlanId) {
            cartItemData.selling_plan = sellingPlanId;
          }
        }
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartItemData)
      });

      if (!response || !response.ok) return false;
      return true;
    } catch (error) {
      return false;
    }
  }

  function updateCart() {
    fetch(`${window.themeVariables.routes.cartUrl}.js`)
      .then(response => response.json())
      .then(cartContent => {
        const quickBuyDrawer = document.querySelector('quick-buy-drawer[open]');
        const quickBuyPopover = document.querySelector('quick-buy-popover[open]');
        
        if (quickBuyDrawer) {
          quickBuyDrawer.open = false;
        }
        
        if (quickBuyPopover) {
          quickBuyPopover.open = false;
        }
        
        const lastAddedItem = cartContent.items[cartContent.items.length - 1];
        document.documentElement.dispatchEvent(new CustomEvent("variant:added", {
          bubbles: true,
          detail: { variant: lastAddedItem }
        }));
        
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { 
            cart: cartContent, 
            openMiniCart: true 
          }
        }));
      })
      .catch(() => {
        toggleLoader(false);
      });
  }

  function toggleLoader(isLoading) {
    let addToCartButton = quantityBreaksElement.querySelector("#AddToCart, [id*='AddToCart']");
    
    if (!addToCartButton) {
      const parentContainer = quantityBreaksElement.closest('quick-buy-popover, quick-buy-drawer, form');
      if (parentContainer) {
        addToCartButton = parentContainer.querySelector("#AddToCart, [id*='AddToCart']");
      }
    }
    
    if (!addToCartButton) {
      addToCartButton = document.getElementById("AddToCart");
    }
    
    if (!addToCartButton) return;

    const buttonLoader = addToCartButton.querySelector(".loader-button__loader");

    if (isLoading) {
      addToCartButton.setAttribute("disabled", "disabled");
      addToCartButton.setAttribute("aria-busy", "true");
      if (buttonLoader) buttonLoader.hidden = false;
      addToCartButton.dataset.loaderStart = Date.now();
    } else {
      const minDuration = 2000;
      const elapsedTime = Date.now() - addToCartButton.dataset.loaderStart;
      const remainingTime = Math.max(0, minDuration - elapsedTime);

      setTimeout(() => {
        addToCartButton.removeAttribute("disabled");
        addToCartButton.setAttribute("aria-busy", "false");
        if (buttonLoader) buttonLoader.hidden = true;
      }, remainingTime);
    }
  }

  function observeFormChanges() {
    const productForm = document.querySelector("form[is='product-form']");
    if (!productForm) return;

    const observer = new MutationObserver(() => {
      initializeAddToCart();
    });

    observer.observe(productForm, { childList: true, subtree: true });
  }

  initializeAddToCart();
  observeFormChanges();
}

// Initialisierung
document.addEventListener("DOMContentLoaded", function () {
  initializeQuantityBreaks();
});

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        const newQuantityBreaks = node.querySelectorAll ? node.querySelectorAll('quantity-breaks') : [];
        if (newQuantityBreaks.length > 0 || node.tagName === 'QUANTITY-BREAKS') {
          setTimeout(() => {
            initializeQuantityBreaks();
          }, 100);
        }
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


document.addEventListener('DOMContentLoaded', function() {
  const scrollButtons = document.querySelectorAll('.scroll-to-btn');
  
  function calculateOffset() {
    const rootStyles = getComputedStyle(document.documentElement);
    let totalOffset = 0;
    
    const headerHeight = rootStyles.getPropertyValue('--header-height').trim();
    if (headerHeight) {
      totalOffset += parseInt(headerHeight);
    }
    
    const announcementBarHeight = rootStyles.getPropertyValue('--announcement-bar-height').trim();
    if (announcementBarHeight) {
      totalOffset += parseInt(announcementBarHeight);
    }
    
    const countsaleHeight = rootStyles.getPropertyValue('--countsale-height').trim();
    if (countsaleHeight) {
      totalOffset += parseInt(countsaleHeight);
    }
    
    return totalOffset;
  }
  
  scrollButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const target = this.getAttribute('data-scroll-target');
      if (!target) return;
      
      let targetElement;
      
      if (target.startsWith('#')) {
        targetElement = document.querySelector(target);
      } else if (target.startsWith('.')) {
        targetElement = document.querySelector(target);
      } else {
        targetElement = document.querySelector('.' + target);
      }
      
      if (targetElement) {
        const offset = calculateOffset();
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth'
        });
      } else {
        console.warn('Scroll-to Ziel nicht gefunden:', target);
      }
    });
  });
});





var isProcessing = false;

function removeProductFromCart() {
  var form = document.querySelector('form.priority-processing');
  if (!form) return;
  var variantInput = form.querySelector('input[name="id"]');
  if (!variantInput) return;
  var variantId = variantInput.value;
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var itemInCart = cart.items.find(item => item.id == variantId);
      if (!itemInCart) return;
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/change.js', true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.send('id=' + encodeURIComponent(variantId) + '&quantity=0');
    });
}

function initialize() {
  removeProductFromCart();
  observeToggleButton();
}

function observeToggleButton() {
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        var checkbox = document.querySelector('#shipping-switch-new');
        if (checkbox) {
          // Event Listener entfernt, da onclick im HTML verwendet wird
          observer.disconnect();
        }
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Diese Funktion wird vom onclick im HTML aufgerufen
function handleCheckoutClick(element) {
  // Prevent default wenn es ein submit button ist
  if (element.type === 'submit') {
    event.preventDefault();
  }
  
  if (isProcessing) return;
  
  var checkbox = document.querySelector('#shipping-switch-new');
  if (checkbox && checkbox.checked) {
    isProcessing = true;
    addProductToCart(function() {
      document.querySelector('#CartDrawer-Checkout').click();
    });
  } else {
    document.querySelector('#CartDrawer-Checkout').click();
  }
}

function addProductToCart(callback) {
  var form = document.querySelector('form.priority-processing');
  if (!form) {
    isProcessing = false;
    return;
  }
  var formData = new FormData(form);
  var variantInput = form.querySelector('input[name="id"]');
  if (!variantInput) {
    isProcessing = false;
    return;
  }
  formData.append('id', variantInput.value);
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js', true);
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.onload = function() {
    if (xhr.status === 200) {
      if (callback) callback();
    } else {
      isProcessing = false;
    }
  };
  xhr.onerror = function() {
    isProcessing = false;
  };
  xhr.send(formData);
}

window.addEventListener('pageshow', function(event) {
  initialize();
});



class TimerCart extends HTMLElement {
  constructor() {
    super();
    this.timerInterval = null;
    this.cartDrawer = document.querySelector("cart-drawer");
    this.remainingTime = this.getSavedTime() || this.getTimerDuration();
  }

  connectedCallback() {
    this.updateTimerDisplay();
    this.observeCartDrawer();

    // **NEU:** Falls wir auf der Cart-Seite sind, Timer direkt starten
    if (this.isCartPage()) {
      this.startTimer();
    }
  }

  observeCartDrawer() {
    if (!this.cartDrawer) return; // Falls kein cart-drawer existiert, beende die Funktion

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "open" && this.cartDrawer.hasAttribute("open")) {
          this.startTimer();
        }
      });
    });

    observer.observe(this.cartDrawer, { attributes: true });
  }

  getTimerDuration() {
    const container = document.querySelector(".containercart");
    if (!container) return 600; // Falls kein Container existiert, Standardwert nehmen

    const duration = parseInt(container.getAttribute("data-timer")) * 60;
    return isNaN(duration) || duration <= 0 ? 600 : duration;
  }

  getSavedTime() {
    const savedTime = sessionStorage.getItem('remainingTime');
    return savedTime ? parseInt(savedTime) : null;
  }

  startTimer() {
    if (this.timerInterval) return; // Verhindert mehrfaches Starten

    this.timerInterval = setInterval(() => {
      if (this.remainingTime <= 0) {
        this.stopTimer();
        this.switchTimerText();
      } else {
        this.remainingTime--;
        sessionStorage.setItem('remainingTime', this.remainingTime);
        this.updateTimerDisplay();
      }
    }, 1000);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  updateTimerDisplay() {
    const timeDisplay = this.querySelector('#time-display');
    if (timeDisplay) {
      const minutes = Math.floor(this.remainingTime / 60);
      const seconds = this.remainingTime % 60;
      timeDisplay.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
  }

  switchTimerText() {
    const timerText = this.querySelector('#timer');
    const timerEndMessage = this.querySelector('#timer-end');

    if (timerText && timerEndMessage) {
      timerText.style.display = 'none';
      timerEndMessage.style.display = 'block';
    }
  }

  // **NEU:** Prüft, ob wir uns auf der Cart-Seite befinden
  isCartPage() {
    return window.location.pathname.includes("/cart");
  }
}

customElements.define('timer-cart', TimerCart);




document.addEventListener('click', function(event) {
  if (event.target.closest('.jdgm-paginate__load-more')) {
    const paginateDiv = document.querySelector('.jdgm-paginate');
    if (paginateDiv) {
      setTimeout(function () {
        paginateDiv.remove();
      }, 300);
    }
  }
});
  